interface SendReplyShortcutHintProps {
	label: string
}

export function SendReplyShortcutHint({ label }: SendReplyShortcutHintProps) {
	return (
		<kbd className="ml-2 hidden sm:inline-flex h-5 items-center rounded border border-primary-foreground/20 bg-primary-foreground/10 px-1.5 font-mono text-[10px] font-medium">
			{label}
		</kbd>
	)
}
